export default __webpack_public_path__ + "static/media/22.004a9ee3.png";